import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {ColumnFilter, ColumnFiltersService} from '../../columns-filters/column-filters.service';
import {merge, Observable} from 'rxjs';
import {distinctUntilChanged, filter, map, tap} from 'rxjs/operators';
import {ColumnFilterInputComponent} from '../column-filter-input/column-filter-input.component';
import {ColumnUnits, Units, UnitsFormattersService} from '../../units-formatters/units-formatters.service';
import {Column} from 'asax-common';
import {AsaxBookmarkingService} from 'asax-bookmarking';

@Component({
  selector: 'asax-result-table-search-table-column-container',
  templateUrl: './column-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnContainerComponent implements OnInit {
  @ViewChild('columnFilter', {static: false}) columnFilterComponent: ColumnFilterInputComponent;

  @Input() column: Column;
  @Input() sortDir: any;

  @Output() outSort = new EventEmitter<any>();

  columnUnitsObservable: Observable<Units>;

  constructor(private readonly columnFiltersService: ColumnFiltersService,
              private readonly unitsFormattersService: UnitsFormattersService,
              private readonly asaxBookmarkingService: AsaxBookmarkingService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.asaxBookmarkingService.getQueryParam(this.column?.id).pipe(
      filter(value => value?.length > 0),
      filter(value => value !== this.column.value),
      tap(value => (this.column = {...this.column, value})),
      tap(() => this.changeDetectorRef.markForCheck())
    ).subscribe();

    merge(
      this.columnFiltersService.columnFiltersRemoved(),
      this.columnFiltersService.columnFilterRemoved(this.column?.id)
    ).pipe(
      tap(value => (this.column = {...this.column, value: undefined})),
      tap(() => this.changeDetectorRef.markForCheck())
    ).subscribe();

    this.columnFiltersService.getColumnFilterIsDisabled(this.column?.id).pipe(
      filter(isDisabled => isDisabled !== this.column.isDisabled),
      tap(isDisabled => (this.column = {...this.column, isDisabled})),
      tap(() => this.changeDetectorRef.markForCheck())
    ).subscribe();

    this.columnUnitsObservable = this.unitsFormattersService.getColumnsUnits().pipe(
      map(columnsUnits => columnsUnits?.find(columnUnits => columnUnits.columnId === this.column.id)),
      map(columnUnits => columnUnits?.units),
      distinctUntilChanged()
    );
  }

  emitSort(): void {
    this.outSort.emit();
  }

  onColumnFilter(columnFilter: ColumnFilter): void {
    this.columnFiltersService.upsertColumnFilter(columnFilter);

    if (!!columnFilter.value) {
      this.asaxBookmarkingService.addParamsToUrl({[columnFilter.id]: columnFilter.value});
    } else {
      this.asaxBookmarkingService.removeParamsFromUrl(columnFilter.id);
    }
  }

  onColumnUnits(columnUnits: ColumnUnits): void {
    this.unitsFormattersService.setColumnsUnits(columnUnits);
  }
}
